import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { updateLogistics } from "../../store/order/order.action";

const STATUSES = [
  "to_be_shipped",
  "picked_up",
  "shipped",
  "in_transit",
  "out_for_delivery",
  "received",
  "delivered",
  "review",
  "returned",
];

const LABELS = {
  to_be_shipped: "To be shipped",
  picked_up: "Picked up",
  shipped: "Shipped",
  in_transit: "In transit",
  out_for_delivery: "Out for delivery",
  received: "Received",
  delivered: "Delivered",
  review: "Review",
  returned: "Returned",
};

export default function LogisticsAdminCard({ item, orderId }) {
  const dispatch = useDispatch();
  const current = item?.logisticsStatus || "to_be_shipped";
  const [next, setNext] = useState(current);
  const [note, setNote] = useState("");
  const [lat, setLat] = useState(item?.courierLocation?.lat ?? "");
  const [lng, setLng] = useState(item?.courierLocation?.lng ?? "");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!orderId || !item?._id) return;
    setBusy(true);
    const payload = {
      orderId,
      itemId: item._id,
      status: next,
      note: note.trim(),
    };
    if (String(lat).trim() !== "" && String(lng).trim() !== "") {
      const numLat = Number(lat);
      const numLng = Number(lng);
      if (isFinite(numLat) && isFinite(numLng)) {
        payload.courierLocation = { lat: numLat, lng: numLng };
      }
    }
    await dispatch(updateLogistics(payload));
    setBusy(false);
    setNote("");
  };

  const lastEntry =
    item?.logisticsHistory && item.logisticsHistory.length > 0
      ? item.logisticsHistory[item.logisticsHistory.length - 1]
      : null;

  return (
    <div className="border p-3 mb-3" style={{ borderRadius: "8px", background: "#fff" }}>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <strong style={{ fontSize: "14px" }}>
          {item?.productId?.productName || "Item"}
        </strong>
        <span
          style={{
            background: "#FFF3CD",
            color: "#856404",
            padding: "3px 10px",
            borderRadius: "6px",
            fontSize: "12px",
            fontWeight: 600,
          }}
        >
          {LABELS[current] || "—"}
        </span>
      </div>

      {lastEntry && (
        <div className="small text-muted mb-2">
          Last update: {LABELS[lastEntry.status] || lastEntry.status}
          {" — "}
          {new Date(lastEntry.at).toLocaleString()}
          {lastEntry.note ? ` — ${lastEntry.note}` : ""}
        </div>
      )}

      <div className="row g-2">
        <div className="col-md-4">
          <label className="form-label small mb-1">Set status to</label>
          <select
            className="form-select form-select-sm"
            value={next}
            onChange={(e) => setNext(e.target.value)}
          >
            {STATUSES.map((s) => (
              <option key={s} value={s}>
                {LABELS[s]}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-8">
          <label className="form-label small mb-1">Note (optional)</label>
          <input
            className="form-control form-control-sm"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="e.g. Picked up at depot, expected arrival 2pm"
          />
        </div>
        <div className="col-md-4">
          <label className="form-label small mb-1">Courier lat</label>
          <input
            className="form-control form-control-sm"
            value={lat}
            onChange={(e) => setLat(e.target.value)}
            placeholder="5.6037"
          />
        </div>
        <div className="col-md-4">
          <label className="form-label small mb-1">Courier lng</label>
          <input
            className="form-control form-control-sm"
            value={lng}
            onChange={(e) => setLng(e.target.value)}
            placeholder="-0.1870"
          />
        </div>
        <div className="col-md-4 d-flex align-items-end">
          <button
            className="btn btn-sm w-100"
            style={{
              background: "#F0C420",
              color: "#000",
              fontWeight: 600,
              border: "none",
            }}
            disabled={busy}
            onClick={submit}
          >
            {busy ? "Updating…" : "Update"}
          </button>
        </div>
      </div>

      {item?.logisticsHistory && item.logisticsHistory.length > 0 && (
        <details className="mt-2">
          <summary className="small text-muted" style={{ cursor: "pointer" }}>
            History ({item.logisticsHistory.length})
          </summary>
          <ul className="small text-muted mt-2 ps-3 mb-0">
            {item.logisticsHistory
              .slice()
              .reverse()
              .map((h, i) => (
                <li key={i}>
                  <strong>{LABELS[h.status] || h.status}</strong>
                  {" — "}
                  {new Date(h.at).toLocaleString()}
                  {h.note ? ` — ${h.note}` : ""}
                </li>
              ))}
          </ul>
        </details>
      )}
    </div>
  );
}
